import script from "./FollowingListModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./FollowingListModal.vue?vue&type=script&setup=true&lang=ts"

import "./FollowingListModal.vue?vue&type=style&index=0&id=2c63b669&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c63b669"]])

export default __exports__